import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

function Stat({ testid, label, value }) {
  return (
    <div className="rounded-2xl border hairline bg-white p-6" data-testid={testid}>
      <div className="text-[11px] uppercase tracking-[0.22em] text-salnes-stone">
        {label}
      </div>
      <div className="font-serif text-3xl text-salnes-ink mt-3 tabular-nums">
        {value === null || value === undefined ? "—" : value.toLocaleString("es-ES")}
      </div>
    </div>
  );
}

export default function ImpactoTransparency({ kpis = {}, topDatasets = [] }) {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-5" data-testid="impacto-transparency-grid">
      <Stat
        testid="impacto-transparency-api-calls"
        label={t("fase7.transparency_api_calls")}
        value={kpis.consultas_api_publica_30d}
      />
      <Stat
        testid="impacto-transparency-reports"
        label={t("fase7.transparency_reports_sealed")}
        value={kpis.informes_publicos_xerados}
      />
      <div
        className="rounded-2xl border hairline bg-white p-6"
        data-testid="impacto-transparency-top-datasets"
      >
        <div className="text-[11px] uppercase tracking-[0.22em] text-salnes-stone">
          {t("fase7.transparency_top_datasets")}
        </div>
        {topDatasets.length === 0 ? (
          <div className="text-salnes-ink text-2xl font-serif mt-3">—</div>
        ) : (
          <ol className="mt-3 space-y-2 text-sm">
            {topDatasets.map((d, i) => (
              <li key={d.dataset} className="flex items-center justify-between">
                <span className="text-salnes-ink">
                  <span className="text-salnes-stone tabular-nums mr-2">{i + 1}.</span>
                  {d.dataset}
                </span>
                <span className="text-salnes-stone tabular-nums">{d.requests}</span>
              </li>
            ))}
          </ol>
        )}
      </div>
      <div className="lg:col-span-3 mt-3">
        <Link
          to="/estatisticas"
          className="inline-flex items-center gap-1.5 text-sm text-salnes-atlantic hover:underline"
          data-testid="impacto-transparency-link"
        >
          {t("fase7.transparency_view_stats")} <ArrowUpRight size={14} />
        </Link>
      </div>
    </div>
  );
}
